import React, { ReactNode } from "react";
import {
  FormControlLabel, 
  Switch, 
  TextField, 
} from "@mui/material";
import styles from "./GenericSwitchTextField.module.css";

interface Props {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  textFieldLabel?: string;
  textFieldValue?: string;
  onTextFieldChange?: (value: string) => void;
  view: "row" | "column";
  children?: ReactNode;
  labelClassName?: string;
  customClassName?: string;
  textFieldError?: boolean;
  textFieldHelperText?: React.ReactNode;
}

const GenericSwitchTextField: React.FC<Props> = ({
  label,
  value,
  onChange,
  textFieldLabel,
  textFieldValue = "",
  onTextFieldChange,
  view,
  children,
  labelClassName,
  customClassName,
  textFieldError,
  textFieldHelperText,
}) => {
  return (
    <div
      className={`${styles.field} ${view === "row" ? styles.row : styles.column}`}
    >
      <FormControlLabel
        control={
          <Switch
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            inputProps={{ "aria-label": "controlled" }}
          />
        }
        label={label}
      />
      {value &&
        (children ||
          (textFieldLabel && onTextFieldChange ? (
            <>
              <label className={styles.titleInput}>
                {textFieldLabel} *
              </label>
              <TextField
                variant="standard"
                placeholder=""
                label=""
                value={textFieldValue}
                onChange={(e) => onTextFieldChange(e.target.value)}
                fullWidth
                error={textFieldError}
                helperText={textFieldHelperText}
                InputProps={{
                  className: customClassName, // estiliza o input real
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  className: labelClassName, // estiliza o label
                  shrink: false,
                }}
              />
            </>
          ) : null))}
    </div>
  );
};

export default GenericSwitchTextField;
